import { render } from "./EditCompany.vue?vue&type=template&id=55e95e46&scoped=true&ts=true"
import script from "./EditCompany.vue?vue&type=script&lang=ts"
export * from "./EditCompany.vue?vue&type=script&lang=ts"

import "./EditCompany.vue?vue&type=style&index=0&id=55e95e46&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e95e46"]])

export default __exports__